import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { rethrowCloseCauseIfNeeded2q8fs9csuucwc as rethrowCloseCauseIfNeeded } from './ByteReadChannelOperations.mjs';
import { get_size2imoy2jq11jxl as get_size } from './core/BytePacketBuilder.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_autoFlush() {
  return false;
}
var ByteWriteChannelClass;
function ByteWriteChannel() {
  if (ByteWriteChannelClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ByteWriteChannel', VOID, VOID, VOID, [0]);
    ByteWriteChannelClass = $;
  }
  return ByteWriteChannelClass;
}
function *flushIfNeeded(_this__u8e3s4, $completion) {
  rethrowCloseCauseIfNeeded(_this__u8e3s4);
  if (_this__u8e3s4.m4n() || get_size(_this__u8e3s4.q4n()) >= 1048576)
    yield* _this__u8e3s4.c4o($completion);
  return Unit_instance;
}
//region block: exports
export {
  flushIfNeeded as flushIfNeeded2jf5glmfh5e3h,
  ByteWriteChannel as ByteWriteChannel3jkhlhzuuoxp1,
};
//endregion

//# sourceMappingURL=ByteWriteChannel.mjs.map
